import { Component, Input } from '@angular/core'

import { Entity } from '../../../models/fund-details.model'
import { FiltersService } from '../../../services/filtersService.service'
const LENGTH_THRESHOLD = 5

@Component({
  selector: 'VFA-compare-tool-checkbox',
  templateUrl: './compare-tool-checkbox.component.html',
  styleUrls: ['./compare-tool-checkbox.component.scss'],
})
export class CompareToolCheckboxComponent {
  @Input() fundInput: Entity
  @Input() comparedFunds: string[]
  @Input() fundIndex: number
  selectedFundList: any = []
  constructor(private filterService: FiltersService) {}

  ngOnChanges() {
    this.fundInput.compareEnabled = this.isContained(
      this.fundInput.profile.fundId,
    )
  }

  // eslint-disable-next-line complexity
  fundAction(event: any) {
    if (event != null) {
      const isDisabledBox =
        (this.comparedFunds.length >= LENGTH_THRESHOLD ||
          this.fundInput.profile.is529) &&
        !this.fundInput.compareEnabled
      const isChecked = event.target.checked
      const fundExists = this.isContained(this.fundInput.profile.fundId)

      if (isDisabledBox) {
        if (fundExists) {
          this.removeFund()
        }
      } else if (isChecked && !fundExists) {
        this.addFund()
      } else if (!isChecked && fundExists) {
        this.removeFund()
      }
    }
  }
  addFund() {
    this.comparedFunds.push(this.fundInput.profile.fundId)
    this.fundInput.compareEnabled = true
    this.filterService.compareFundCount = this.comparedFunds.length
    this.filterService.compareFunds.next(this.comparedFunds)
  }

  removeFund() {
    for (let i = 0; i < this.comparedFunds.length; i++) {
      if (this.comparedFunds[i] === this.fundInput.profile.fundId) {
        this.fundInput.compareEnabled = false

        this.comparedFunds.splice(i, 1)
        this.filterService.compareFundCount = this.comparedFunds.length
        this.filterService.compareFunds.next(this.comparedFunds)
      }
    }
  }

  isContained(fundId: string) {
    return this.comparedFunds.filter((f) => f === fundId).length > 0
  }
}
